import React from 'react';
import cn from 'classnames';

import cls from './Card.module.scss'

interface Props {
    top?: React.ReactNode
    bottom?: React.ReactNode
    children?: React.ReactNode
    color?: 'white'|'pink'|'black'|'gray'
    shadow?: boolean
    className?: string
    style?: any
    id?: string
}

export const Card = ({id, top, children, bottom, color = 'white', className, style}: Props) => (
    <div id={id} style={style} className={cn([
        cls.card,
        color==='white' && cls.white,
        color==='pink' && cls.pink,
        color==='black' && cls.black,
        color==='gray' && cls.gray,
        className && className,
    ])}>
        <div className={cls.top}>{top || children}</div>
        <div className={cls.bottom}>{bottom}</div>
    </div>
)